import React, { useEffect, useState } from "react";
import ContenedorPrincipal from "../elementos/basicos/ContenedorPrincipal";
import BotonesAccion from "../elementos/eventos/navegacion_y_accion/BotonesAccion";
import EnhancedTable from "../elementos/basicos/TablaDepartamentoLista";
import { useLocation, useNavigate } from 'react-router-dom';
import { fetchEliminarDepartamentos, fetchNegociosData, fetchDepartamentosData, fetchDepartamentosFiltersData } from '../../peticiones_API/PeticionesGestionPersonasDepartamentos';
import { ConfirmacionEliminarDepartamento, Error } from './../elementos/eventos/avisos/VentanaEmergente';
import Titulo from "./../elementos/basicos/Titulo";
import styled from 'styled-components';

const GestionPersonasDepartamentos = () => {
    const location = useLocation();
    let params = new URLSearchParams(location.search);
    let paginaActual = parseInt(params.get("pagina"));
    let registrosPorPag = parseInt(params.get("registrosPorPag"));
    const urlPadre = window.location.pathname;
    const navigate = useNavigate();

    let busqueda = params.get("busqueda") || null;
    let negocio = params.get("negocio");
    let departamento = params.get("departamento");
    let ordenarColumna = params.get("ordenarColumna");
    let orden = params.get("orden");
    let tipo = params.get("tipo");

    const [loading, setLoading] = useState(false);

    const [negocios, setNegocios] = useState([]);
    const [departamentos, setDepartamentos] = useState([]);
    const [todosLosDepartamentos, setTodosLosDepartamentos] = useState([]);

    const [selected, setSelected] = useState([]);
    const [recargar, setRecargar] = useState(false);
    const [eliminarSeleccion, setEliminarSeleccion] = useState({ atributo: 'visible', valor: null });
    const [data, setData] = useState({
            meta: {},
            rows: []
        });

    const construirParametrosURL = (pagina) => {
        let urlParams = `?pagina=${pagina}&registrosPorPag=${registrosPorPag}`;
        if (busqueda !== null && busqueda !== '' && busqueda !== undefined) {
            urlParams += `&busqueda=${busqueda}`;
        }
        if (negocio !== null) {
            urlParams += `&negocio=${negocio}`;
        }
        if (tipo !== null && tipo !== undefined && tipo !== "") {
            urlParams += `&tipo=${tipo}`;
        }
        if (ordenarColumna !== null) {
            urlParams += `&ordenarColumna=${ordenarColumna}`;
        }
        if (orden !== null) {
            urlParams += `&orden=${orden}`;
        }
        return urlParams;
    };

        useEffect(() => {
            async function fechtPrincipal() {
                try {
                    const currentParams = new URLSearchParams(location.search);
                    paginaActual = parseInt(currentParams.get("pagina"));
                    registrosPorPag = parseInt(currentParams.get("registrosPorPag"));
                    busqueda = currentParams.get("busqueda") || null;
                    negocio = currentParams.get("negocio");
                    ordenarColumna = currentParams.get("ordenarColumna");
                    orden = currentParams.get("orden");
                    tipo = currentParams.get("tipo");

                    if (!paginaActual || !registrosPorPag) {
                        const departamentosResponse = await fetchDepartamentosFiltersData(paginaActual, registrosPorPag, negocio, busqueda, ordenarColumna, orden, tipo);
                        console.log("departamentosResponse ",departamentosResponse);
                        const { data: departamentosData, meta } = departamentosResponse;

                        paginaActual = meta.current_page;
                        registrosPorPag = meta.per_page;
                        
                        navigate(`${urlPadre}?pagina=${paginaActual}&registrosPorPag=${registrosPorPag}`);
                        setData({
                            meta,
                            rows: departamentosData
                        });                    } else {
                        const urlParams = construirParametrosURL(paginaActual);
                        navigate(`${urlPadre}${urlParams}`);
                        const departamentosResponse = await fetchDepartamentosFiltersData(paginaActual, registrosPorPag, negocio, busqueda, ordenarColumna, orden, tipo);
                        const { data: departamentosData, meta } = departamentosResponse;
                        
                        //Para arreglar el problema de estar en otra pagina y que no haya datos
                        if (departamentosData.length === 0 && paginaActual > 1 && meta.total > 0) {
                            const urlParamsPage1 = construirParametrosURL(1);
                            navigate(`${urlPadre}${urlParamsPage1}`);
                            return;
                        }
                        
                        setData({
                            meta,
                            rows: departamentosData
                        });
                    }
                    const negociosResponse = await fetchNegociosData();
                    setNegocios(negociosResponse);

                    const todosLosDepartamentosResponse = await fetchDepartamentosData();
                    setTodosLosDepartamentos(todosLosDepartamentosResponse);

                    const departamentosResponse = await fetchDepartamentosFiltersData();
                    setDepartamentos(departamentosResponse);
                    
                } catch (error) {
                    console.log("Ha habido un error:", error);
                } finally {
                    setLoading(false);
                }
            }
            fechtPrincipal();
        }, [location.search, recargar]);

        const confirmDialog = ConfirmacionEliminarDepartamento();

    const funcionEliminar = async () => {
        if(selected.length === 0){
            eliminarSeleccion.valor = null;
            return;
        };
        const confirm = await confirmDialog.showAlert("eliminar","departamentos");
        if (confirm) {
            let departamentosEliminar = [];
            if (eliminarSeleccion.valor === false && selected.length !== 0) {
                setEliminarSeleccion((prevState) => ({
                    ...prevState,
                    valor: null,
                }));
                departamentosEliminar = selected;
                try {
                    await fetchEliminarDepartamentos(departamentosEliminar);
                } catch (error) {
                    Error();
                    console.error("Error al eliminar departamentos:", error);
                    
                }
                setSelected([])
            }
            setRecargar(!recargar)
        }
    }
    
    if (eliminarSeleccion.valor !== null) {
        funcionEliminar();
    }

    const header = [
        {
            id: 'tipo',
            numeric: false,
            disablePadding: true,
            label: 'Tipo',
        },
        {
            id: 'nombre',
            numeric: false,
            disablePadding: true,
            label: 'Nombre',
        },
        {   id: 'depende_de',
            numeric: false,
            disablePadding: false,
            label: 'Dependencia',
        },
        {   id: 'negocios',
            numeric: true,
            disablePadding: false,
            label: 'Negocios',
        },
        {
            id: 'modificar',
            numeric: true,
            disablePadding: false,
            label: '',
        }
    ];

    if (loading) {
        return <div>Cargando...</div>;
    }

    return ( 
        <>     
            <CabeceraForm>
                <Titulo
                    texto="DEPARTAMENTOS"
                    
                    tituloTabla="true"
                />
            </CabeceraForm>
            <EnhancedTable
                data={data.rows}
                header={header}
                meta={data.meta}
                negocios={negocios}
                departamentos={departamentos}
                todosLosDepartamentos={todosLosDepartamentos}
                selected={selected}
                setSelected={setSelected}
                eliminarSeleccion={eliminarSeleccion}
                setEliminarSeleccion={setEliminarSeleccion}
            />
        </>
     );
}

const CabeceraForm = styled.div`
    margin: 0 0% 1% 0%;
`
 
export default GestionPersonasDepartamentos;